import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=3aaeec87&"
import script from "./Toolbar.vue?vue&type=script&lang=js&"
export * from "./Toolbar.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=3aaeec87&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports